import { p as proxyCustomElement, H, h, c as Host } from './p-92c4a1ea.js';
import './p-a57042e3.js';
import { h as hideElementFromAccessibilityAPI, b as accessibility } from './p-756e7dc5.js';
import { u as useRef } from './p-e952b680.js';
import { a as ComponentUtils } from './p-de830ba7.js';
import { F as FocusVisible } from './p-fbd8eb80.js';
import { d as defineCustomElement$3 } from './p-03bc42d4.js';
import { d as defineCustomElement$2 } from './p-3a198e00.js';
const breadcrumbItemCss = ".sc-owc-breadcrumb-item-h{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;color:var(--one-color-foreground-intensity-high);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:none;min-height:var(--one-spacing-size-s)}.sc-owc-breadcrumb-item-h:last-of-type .owc-breadcrumb-item__icon.sc-owc-breadcrumb-item{display:none}.sc-owc-breadcrumb-item-h:focus-visible:not(.owc-breadcrumb-item--disabled) .owc-breadcrumb-item__hyperlink.sc-owc-breadcrumb-item{outline:var(--one-spacing-outline-semibold) solid var(--one-color-interaction-focus-brand-high);outline-offset:var(--one-spacing-outline-semibold);color:var(--one-color-interaction-focus-brand-base)}.owc-soft-focus.sc-owc-breadcrumb-item-h:not(.owc-breadcrumb-item--disabled) .owc-breadcrumb-item__hyperlink.sc-owc-breadcrumb-item{outline:var(--one-spacing-outline-semibold) solid var(--one-color-interaction-focus-brand-high);outline-offset:var(--one-spacing-outline-semibold);color:var(--one-color-interaction-focus-brand-base)}.owc-breadcrumb-item--focused.sc-owc-breadcrumb-item-h:not(.owc-breadcrumb-item--disabled) .owc-breadcrumb-item__hyperlink.sc-owc-breadcrumb-item{outline:var(--one-spacing-outline-semibold) solid var(--one-color-interaction-focus-brand-high);outline-offset:var(--one-spacing-outline-semibold);color:var(--one-color-interaction-focus-brand-base)}@supports not selector(:focus-visible){.sc-owc-breadcrumb-item-h:focus:not(.owc-breadcrumb-item--disabled) .owc-breadcrumb-item__hyperlink.sc-owc-breadcrumb-item{outline:var(--one-spacing-outline-semibold) solid var(--one-color-interaction-focus-brand-high);outline-offset:var(--one-spacing-outline-semibold);color:var(--one-color-interaction-focus-brand-base)}.sc-owc-breadcrumb-item-h:focus-within:not(.owc-breadcrumb-item--disabled) .owc-breadcrumb-item__hyperlink.sc-owc-breadcrumb-item{outline:var(--one-spacing-outline-semibold) solid var(--one-color-interaction-focus-brand-high);outline-offset:var(--one-spacing-outline-semibold);color:var(--one-color-interaction-focus-brand-base)}.owc-soft-focus.sc-owc-breadcrumb-item-h:not(.owc-breadcrumb-item--disabled) .owc-breadcrumb-item__hyperlink.sc-owc-breadcrumb-item{outline:var(--one-spacing-outline-semibold) solid var(--one-color-interaction-focus-brand-high);outline-offset:var(--one-spacing-outline-semibold);color:var(--one-color-interaction-focus-brand-base)}.owc-breadcrumb-item--focused.sc-owc-breadcrumb-item-h:not(.owc-breadcrumb-item--disabled) .owc-breadcrumb-item__hyperlink.sc-owc-breadcrumb-item{outline:var(--one-spacing-outline-semibold) solid var(--one-color-interaction-focus-brand-high);outline-offset:var(--one-spacing-outline-semibold);color:var(--one-color-interaction-focus-brand-base)}}.sc-owc-breadcrumb-item-h .owc-breadcrumb-item__hyperlink.sc-owc-breadcrumb-item a.sc-owc-breadcrumb-item:visited{color:unset !important}@media (hover: hover){.sc-owc-breadcrumb-item-h .owc-breadcrumb-item__hyperlink.sc-owc-breadcrumb-item:hover:not(.owc-breadcrumb-item--disabled){color:var(--one-color-interaction-hover-brand-high);text-decoration:underline}.sc-owc-breadcrumb-item-h .owc-breadcrumb-item__hyperlink.owc-soft-hover.sc-owc-breadcrumb-item:not(.owc-breadcrumb-item--disabled){color:var(--one-color-interaction-hover-brand-high);text-decoration:underline}}.sc-owc-breadcrumb-item-h .owc-breadcrumb-item__hyperlink.sc-owc-breadcrumb-item:active{color:var(--one-color-interaction-active-brand-high);text-decoration:underline}.sc-owc-breadcrumb-item-h .owc-breadcrumb-item__hyperlink.owc-soft-active.sc-owc-breadcrumb-item{color:var(--one-color-interaction-active-brand-high);text-decoration:underline}.sc-owc-breadcrumb-item-h .owc-breadcrumb-item__icon.sc-owc-breadcrumb-item{height:var(--one-spacing-size-xs);font-size:var(--one-spacing-size-xs);line-height:var(--one-spacing-size-xs)}.owc-breadcrumb-item--disabled.sc-owc-breadcrumb-item-h .owc-breadcrumb-item__hyperlink.sc-owc-breadcrumb-item{color:var(--one-color-foreground-intensity-high)}";
const OwcBreadcrumbItemStyle0 = breadcrumbItemCss;
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const BreadcrumbItem = /*@__PURE__*/proxyCustomElement(class BreadcrumbItem extends H {
  constructor() {
    super();
    this.__registerHost();
    this.hypertextRef = useRef();
    this.component = new ComponentUtils(this, {
      patchFocusMethod: () => this.focusHypertextElement(),
      patchBlurMethod: () => this.blurHypertextElement()
    });
    this.isDisabled = () => this.disabled || this.parentDisabled;
    this.focusHypertextElement = () => {
      var _a, _b;
      if (!this.disabled && !this.focused) {
        (_b = (_a = this.hypertextRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.focused = true;
      }
    };
    this.blurHypertextElement = () => {
      var _a, _b;
      if (this.focused) {
        (_b = (_a = this.hypertextRef.current) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.focused = false;
      }
    };
    this.url = '';
    this.icon = 'chevron_right';
    this.iconFamily = 'outlined';
    this.disabled = false;
    this.parentDisabled = false;
    this.hyperlinkProps = undefined;
    this.focused = false;
  }
  onFocusStateChange(flag) {
    this.focused = flag;
  }
  render() {
    const hostClasses = this.component.getHostBemClasses({
      disabled: this.isDisabled(),
      focused: this.focused
    });
    const _a = this.hyperlinkProps || {},
      {
        ref: hyperlinkRef,
        className: hyperlinkClassName,
        onclick: onHyperlinkClick
      } = _a,
      hyperlinkProps = __rest(_a, ["ref", "className", "onclick"]);
    const iconClasses = this.component.getChildBemClasses('icon', hostClasses);
    const hyperlinkClasses = this.component.getChildBemClasses('hyperlink', hostClasses, {}, hyperlinkClassName);
    return h(Host, Object.assign({
      key: '6b110d292b4b384a4f39528bc2364f9fc3168801',
      class: hostClasses
    }, accessibility({
      role: 'listitem'
    })), h("owc-hyperlink", Object.assign({
      key: '36cc5be68a348d4ece856f7de0b3a882d3695b4b',
      class: hyperlinkClasses,
      size: "small",
      target: "_self",
      href: this.url,
      disabled: this.isDisabled()
    }, hyperlinkProps, {
      ref: el => this.hypertextRef(el, [hyperlinkRef])
    }), h("slot", {
      key: 'c5694b39b6d964856d5534400d35248158d49400'
    })), this.icon ? h("owc-icon", Object.assign({}, hideElementFromAccessibilityAPI(), {
      class: iconClasses,
      name: this.icon,
      family: this.iconFamily,
      status: "inherit"
    })) : null);
  }
  get hostElement() {
    return this;
  }
  static get style() {
    return OwcBreadcrumbItemStyle0;
  }
}, [6, "owc-breadcrumb-item", {
  "url": [1],
  "icon": [1],
  "iconFamily": [1, "icon-family"],
  "disabled": [4],
  "parentDisabled": [516, "parent-disabled"],
  "hyperlinkProps": [16],
  "focused": [32]
}]);
__decorate([FocusVisible({
  targetElement: host => {
    var _a;
    return (_a = host.hypertextRef) === null || _a === void 0 ? void 0 : _a.current;
  }
})], BreadcrumbItem.prototype, "onFocusStateChange", null);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-breadcrumb-item", "owc-hyperlink", "owc-icon"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-breadcrumb-item":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, BreadcrumbItem);
        }
        break;
      case "owc-hyperlink":
        if (!customElements.get(tagName)) {
          defineCustomElement$3();
        }
        break;
      case "owc-icon":
        if (!customElements.get(tagName)) {
          defineCustomElement$2();
        }
        break;
    }
  });
}
const OwcBreadcrumbItem = BreadcrumbItem;
const defineCustomElement = defineCustomElement$1;
export { OwcBreadcrumbItem, defineCustomElement };